var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-body"},[_c('div',{staticClass:"dev-body-content"},[_c('Downloads'),_c('DevFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }